import styled from 'styled-components';

export const Container = styled.div`
  .btn-hide-search {
    right: -30px;
    top: 20px;
    height: 60px;
    width: 60px;
    background: #fff;
    border-radius: 100%;
    padding: 6px 5px 0 0;
    text-align: right;
    transition: all 1s;

    @media only screen and (max-width: 768px) {
      display: none;
    }

    i {
      transform: rotate(180deg);
    }

    &:hover {
      background: #fff;
    }
  }

  .hide-bar {
    .btn-hide-search {
      i {
        transform: rotate(0deg);
      }
    }
  }

  .btn-hide-documents {
    right: -30px;
    top: 20px;
    height: 34px;
    width: 30px;
    background-color: #03d6a5 !important;
    border-radius: 0 5px 5px 0;
    text-align: right;
    transition: all 1s;
  }

  .result-container {
    transition: all 1s;
  }

  .filter {
    &-button {
      @extend .shadow;
    }

    @media (min-width: 992px) {
      &-bar {
        position: fixed;
        top: 3.5em;
        left: 5px;
        height: 100%;
        background: #fff;
        border-right: 1px solid $gray-300;
        z-index: 13;
        transition: all 1s;

        &.hide-bar {
          transform: translateX(-100%);
        }
      }

      &-form {
        max-height: 85%;
        overflow-x: hidden;
        overflow-y: scroll;
        position: relative;

        &::-webkit-scrollbar {
          -webkit-appearance: none;
          width: 7px;

          &-thumb {
            border-radius: 4px;
            background-color: rgba(0, 0, 0, 0.5);
            -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
          }
        }
      }

      &-button {
        position: fixed;
        bottom: 0;
        left: 5px;
      }
    }
  }

  .flash-message-notification {
    padding-left: 25%;

    @media only screen and (max-width: 768px) {
      padding-left: 0;
    }
  }
`;
